<template>
  <VSnackbar v-model="isSnackbar" multi-line location="top" :color="snackbar.color">
    {{ snackbar.text }}
    <template v-slot:actions>
      <VBtn :color="'#fff'" variant="text" @click="closeSnackbar"> Close </VBtn>
    </template>
  </VSnackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'SnackbarComponent',
  computed: {
    ...mapGetters('main', ['isSnackbar', 'snackbar'])
  },
  methods: {
    ...mapActions('main', ['hideSnackbar']),
    closeSnackbar() {
      this.hideSnackbar();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './Snackbar';
</style>
